import React from 'react';
import Picture from "../shared/components/Picture";
import { useReactAppState } from "../shared/containers/utils";

function FeaturedMatchLoader() {
  const { t } = useReactAppState();

  return (
    <div className="mls-o-match-strip mls-o-match-strip--post mls-o-match-strip--matches mls-o-match-strip--hide-promo ">
      <div className="mls-o-match-strip__match">
        <div className="mls-o-match-strip__header">
          <div className="mls-o-match-strip__match-info">
            <div className="mls-o-match-strip__match-title">
              <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--4rem" />
            </div>
            <div className="mls-o-match-strip__venue">
              <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--5rem" />
            </div>
          </div>
          <div className="mls-o-sponsor">
            <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--2rem" />
          </div>
        </div>
        <div className="mls-o-match-strip__club-group">
          <div className="mls-o-match-strip__club mls-o-match-strip__club--home ">
            <div className="mls-o-match-strip__club-name">
              <span className="mls-o-match-strip__club-logo">
                <Picture
                  extraClasses="mls-o-loading mls-o-loading--glow"
                  src="/assets/images/Fallbacklogo-grey.png"
                  title={t("fallback_logo")} />
              </span>
              <div className="mls-o-match-strip__club-short-name">
                <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--3rem" />
              </div></div>
          </div>
          <div className="mls-o-match-strip__club-separator">
            <div className="mls-o-match-strip__match-period">
              <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--3rem" />
            </div>
            <div className="mls-o-match-strip__score-box">
              <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--3rem" />
            </div>
          </div>
          <div className="mls-o-match-strip__club mls-o-match-strip__club--away ">
            <div className="mls-o-match-strip__club-name">
              <span className="mls-o-match-strip__club-logo">
                <Picture
                  extraClasses="mls-o-loading mls-o-loading--glow"
                  src="/assets/images/Fallbacklogo-grey.png"
                  title={t("fallback_logo")} />
              </span>
              <div className="mls-o-match-strip__club-short-name">
                <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--3rem" />
              </div>
            </div>
          </div>
        </div>
        <div className="mls-o-match-strip__cta-wrapper">
          <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--5rem" />
        </div>
      </div>
    </div>
  );
}

export default FeaturedMatchLoader;
